<template>
  <div>
    <div class="block">
      <div class="title-container">
        <h3>Opdrachtomschrijving</h3>
        <button class="white-pill-s" @click="$emit('goTo')">
          Bewerken
        </button>
      </div>
      <div>
        <span
          class="error-text pointer"
          @click="$emit('goTo')"
          v-if="!description"
          >Opdrachtomschrijving ontbreekt nog, klik hier.</span
        >
        <p class="instruction">{{ description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['description'],
  data() {
    return {}
  },
  methods: {},
  computed: {},
  created() {
    if (this.description.length < 1) {
      this.$emit('addError', 'descriptionError')
    } else {
      this.$emit('removeError', 'descriptionError')
    }
  }
}
</script>

<style lang="scss" scoped>
.instruction {
  white-space: pre-line;
}
</style>
